import { useEffect } from 'react';

const REVEAL_SELECTOR = '[data-reveal]';
const FALLBACK_REVEAL_MS = 2600;
const TRANSITION = 'opacity 900ms, transform 900ms cubic-bezier(.2,0,.2,1)';

const revealElement = (el: HTMLElement) => {
  el.style.opacity = '1';
  el.style.transform = 'none';
};

/**
 * 스크롤 리빌 — IntersectionObserver 대신 getBoundingClientRect.
 * 감춤/표시는 인라인 스타일만 사용해 JS 실패 시에도 콘텐츠가 영구 은닉되지 않게 한다.
 */
export const useReveal = () => {
  useEffect(() => {
    const nodes = Array.from(document.querySelectorAll<HTMLElement>(REVEAL_SELECTOR));

    if (nodes.length === 0) {
      return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      nodes.forEach(revealElement);
      return;
    }

    nodes.forEach((el) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = TRANSITION;
    });

    const onScroll = () => {
      const threshold = window.innerHeight * 0.9;
      nodes.forEach((el) => {
        if (el.getBoundingClientRect().top < threshold) {
          revealElement(el);
        }
      });
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    const timerId = window.setTimeout(() => {
      nodes.forEach(revealElement);
    }, FALLBACK_REVEAL_MS);

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.clearTimeout(timerId);
    };
  }, []);
};
